/**
 * Mobile Navigation
 */
import $ from 'jquery';

// Apply dynamic header height as CSS variable
function updateNavMobileTop() {
  const header = document.querySelector('.site-header');
  const navMobile = document.querySelector('.nav-mobile');

  if (header && navMobile) {
    const headerHeight = header.offsetHeight;
    navMobile.style.setProperty('--site-header-height', `${headerHeight}px`);
  }
}

// Run on load and on resize
window.addEventListener('load', updateNavMobileTop);
window.addEventListener('resize', updateNavMobileTop);

// Toggle mobile nav
$('[data-toggle-nav-mobile]').on('click', event => {
  event.preventDefault();

  const $button = $(event.currentTarget);
  const $menu = $('.nav-mobile');

  const isOpen = $button.hasClass('hamburger--active');

  $button.toggleClass('hamburger--active');
  $menu.toggleClass('nav-mobile--visible');

  const newState = !isOpen;
  $button.attr('aria-expanded', newState.toString());
});

// Toggle nested menu items
$('.nav-mobile .caret').on('click', event => {
  event.preventDefault();
  $(event.currentTarget)
    .parent('li')
    .toggleClass('sub-menu-is-visible');
});

// Hide online banking login button on scroll on mobile
const navButton = document.querySelector('.secondary-nav--mobile');
const sentinel = document.getElementById('scroll-sentinel');

if (navButton && sentinel) {
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          if (!navButton.classList.contains('is-hidden')) {
            navButton.classList.add('is-hidden');
            setTimeout(() => {
              navButton.classList.add('u--display-none');
            }, 100);
          }
        } else {
          navButton.classList.remove('is-hidden', 'u--display-none');
        }
      });
    },
    {
      root: null,
      threshold: 0,
    }
  );

  observer.observe(sentinel);
}
